const ENV = process.env.REACT_APP_ENVIRONMENT || "local";

const ENVIRONMENTS = {
    prod: {
        apiUrl: "https://be.tucum.it/",
        firebaseDatabaseUrl: "https://tucum-c41a2.firebaseio.com"
    },
    test: {
        apiUrl: "https://test-be.tucum.it",
        firebaseDatabaseUrl: "https://tucum-c41a2-test.firebaseio.com"
    },
    local: {
        apiUrl: "http://localhost:8080/",
        firebaseDatabaseUrl: "https://tucum-c41a2-test.firebaseio.com"
    }
};

const environment = ENVIRONMENTS[ENV];

if (!environment) {
    throw new Error("Invalid REACT_APP_ENVIRONMENT: " + ENV + ". Use prod, test, or local.");
}

// Authentication and Storage currently use the production Firebase project in every environment.
export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyA2wiUaVvvKXI9mUlAbX9zhHgvwJXaRW3o",
    authDomain: "tucum-c41a2.web.app",
    databaseURL: environment.firebaseDatabaseUrl,
    projectId: "tucum-c41a2",
    storageBucket: "tucum-c41a2.appspot.com",
    messagingSenderId: "32059313951"
};

export const APP_ENV = ENV;
export const ROOT_URL = environment.apiUrl;
export const FIREBASE_DB_URL = environment.firebaseDatabaseUrl;